import React from 'react';

    const CommonProperties = {
            // "Visible" : "",
            // "Enable" : "",
            // "Mandatory" : "",
            // "EnableMandatoryOnDisable" : "",
            // "FontSize" : "",
            // "LineBreak" : "",
            // "FontWeight" : "",
            // "MergeCell" : "",
            // "FontStyle" : "",
            // "FontFamily" : "",
            // "Style" : "",
            // "FontColor" : "", 
            // "BackColor" : "",
            // "ReadOnly" : "",
            // "ColumnTooltip" : "",
            // "Summary" : "",
            // "Label-InputAlignment" : "",
            // "CustomControlId" : ""
        }

export default CommonProperties;
